import React from "react";
import styles from "./styles.module.scss";
import Image from "@/app/components/image";
import {Assets} from "@/app/utils/assets";

interface TipProps {
  onChange?: () => void;
  children?: React.ReactNode;
}

const Tip: React.FC<TipProps> = ({
                                   onChange = () => {
                                   },
                                   children = "Continue",
                                 }) => {
  return (
    <button
      className={styles.tip}
      onClick={onChange}
    >
      {children} <Image asset={Assets.close}/></button>
  );
};

export default Tip;